import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { withAuthorization } from "../../common/auth/session";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import useRefreshProfile from "../../common/Hooks/useRefreshProfile";

import "./plans.scss";
import Aos from "aos";
import "aos/dist/aos.css";

import Navbar from "../../common/components/HomeNavbar";
import PlansOverview from "./components/PlansOverview";
import EnterpriseContact from "./components/EnterpriseContact";
import Checkout from "./components/Checkout";
import Confirmation from "./components/Confirmation";
import BackButtonRow from "./components/BackButtonRow";

const Pricing = () => {
  useRefreshProfile(); // hook to refresh profile data

  const pricingState = useSelector((state) => state.pricing.uiState);

  useEffect(() => {
    // animation
    Aos.init({
      duration: 3000,
      delay: 200,
    });
    // segment event
    window.analytics.track("Visited Pricing Page");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        style={{
          flexDirection: "row",
          width: "100%",
          backgroundColor: " #141414",
        }}
      >
        <div className="pricepage-container">
          <BackButtonRow />

          {pricingState === "plans" && <PlansOverview />}

          {pricingState === "enterprise" && <EnterpriseContact />}

          {/* {pricingState === "checkout" && <Checkout />} */}

          {/* {pricingState === "confirmation" && <Confirmation />} */}
        </div>
      </div>
    </>
  );
};

export default Pricing;
